import Vue from 'vue';
import Router from 'vue-router';
// import Error404 from '@/views/Error404';
// import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
   routes: [
      {
         path: '*',
         name: 'home',
         //component: Home
         component: () => import('@/views/Default')
      },
      // {
      //    path: '*',
      //    component: Error404
      // }
   ]
});
